import type { PostEventType } from '@/client/services/worlds'

import type { PostEventDetails } from '@/components/Community/Post/types'

export function assertPostEventType<T extends PostEventType>(
  postEvent: PostEventDetails,
  type: T
): asserts postEvent is PostEventDetails & { type: T } {
  if (postEvent.type !== type) {
    throw new Error(`Expected '${type}', got ${postEvent.type}`)
  }
}
